export const NATURAL_PERSON = 'natural_person'
export const LEGAL_ENTITY = 'legal_entity'

export const ALL_CLIENT_LEGAL_FORMS = [NATURAL_PERSON, LEGAL_ENTITY] as const

export type ClientLegalForm = (typeof ALL_CLIENT_LEGAL_FORMS)[number]
